import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EntryNoteService {

  private URL = environment.api + "api/erp/entry-notes";

  constructor(private http: HttpClient) { }

  getEntryNotes() {
    return this.http.get(this.URL);
  }

  getEntryNoteById(id) {
    return this.http.get(this.URL + `/${id}`);
  }

  createEntryNote(request) {
    return this.http.post(this.URL, request);
  }

  updateEntryNote(id, request) {
    return this.http.put(this.URL + `/${id}`, request);
  }

  deleteEntryNote(id) {
    return this.http.delete(this.URL + `/${id}`);
  }

  getEntryNoteDetails(id) {
    return this.http.get(this.URL + `/details/${id}`);
  }

  getEntryNotesAll() {
    return this.http.get(this.URL + '/');
  }

  getEntryNotesAllAssociated() {
    return this.http.get(this.URL + '/notes-associated');
  }

  getEntryNotesAllNotAssociated() {
    return this.http.get(this.URL + '/notes-no-associated');
  }

  isExisteOtherAssociationEntrynoteOrder(entryNoteId: number, orderId: number) {
    return this.http.get(this.URL + `/associated-orders/${entryNoteId}/order/${orderId}`);
  }
}
